import '../css/Calculator.css'
import { useState } from 'react';
import ButtonYellow from './ButtonYellow.js'

const Calculator = ({text, lang}) => {
    const [visible, setVisible] = useState(true);
    const [error, setError] = useState(false);
    function calculateBikeSize() {
        try{
            const height = Number(document.getElementById('calculator_height').value)
            const inseam = Number(document.getElementById('calculator_leg').value)
            if (!height || !inseam){
                setError(true);
                setTimeout(() => setError(false), 5000)
                document.getElementById('size_result').innerText = "?";
                return 0;
            }
            setError(false);
            const frame = inseam * 0.226;
            document.getElementById('height').value = height
            let size = "M";
    
            if (frame >= 21) size = "XL";
            else if (frame >= 19) size = "L";
            else if (frame >= 17) size = "M";
            else size = "S";
            setVisible(false)
            setTimeout(() => {
                document.getElementById('size_result').innerText = size;
                setVisible(true)
            }, 300)
            return {
                frame: frame.toFixed(1),
                size,
            };
        }
        catch{}
    }
    return (
        <div className="calculator">
            <h3>{text["title_4"][lang]}</h3>
            <h6>{text["subtitle_4"][lang]}</h6>
            <div>
                <div>
                    <label data-id="height">
                        <div>{text["your_height"][lang]}</div>
                        <input type='number' placeholder='0' id="calculator_height" className={error ? "input_error" : ""} />
                    </label>
                    <label data-id="weight">
                        <div>{text["leg_length"][lang]}</div>
                        <input type='number' placeholder='0' id="calculator_leg" className={error ? "input_error" : ""} />
                    </label>
                </div>
                <div>
                    <div>{text['your_size'][lang]}</div>
                    <div id='size_result' className={visible ? "" : "hidden"}>?</div>
                    <ButtonYellow text={text['calculate'][lang]} onclick={() => {calculateBikeSize()}}></ButtonYellow>
                </div>
            </div>
        </div>
    )
}

export default Calculator;